<template>
  <div style="margin-top:15px;padding:0px 20px;">
    <div class="mode_box">
      <el-form class="form_all_box" ref="formData" :model="form" :rules="rules">
        <el-form-item label="承运主体" prop="branchCode">
          <el-select
            v-model="form.branchCode"
            placeholder="请选择承运主体"
            @change="getTaxPoint"
          >
            <el-option
              v-for="item in partyGroupOptions"
              :key="item.branchCode"
              :label="item.branchName"
              :value="item.branchCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="服务费率(%)" prop="taxPoint">
          <el-input
            :disabled="isDisabled"
            v-model="form.taxPoint"
            type="number"
            min="0"
            max="100"
            placeholder="请输入服务费(%)"
          />
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align:right;margin-top:90px;">
      <el-button @click="cancelModel">取消</el-button>
      <el-button @click="submitForm" type="primary">确认切换</el-button>
    </div>
  </div>
</template>
<script>
import {
  switchingShipmentServiceFee,
  updateTaxFee,
  switchSave
} from "@/api/shipment";
import request from "@/utils/request";
export default {
  props: {
    branchInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      partyGroupOptions: [],
      form: {
        branchCode: "",
        taxPoint: "",
        id: ""
      },
      rules: {
        branchCode: [
          { required: true, message: "请选择承运主体", trigger: "change" }
        ],
        taxPoint: [
          { required: true, message: "请输入服务费率", trigger: "blur" }
        ]
      },
      isDisabled: false
    };
  },
  watch: {
    branchInfo: {
      handler(newVal) {
        if (newVal) {
          console.log("传递的信息=========", newVal);
          // this.form.id = newVal.id;
          this.form.partyCode = newVal.partyCode;
          this.switchingShipmentServiceFee(newVal.partyCode);
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {},
  methods: {
    async submitForm() {
      if (this.form.taxPoint === 0) {
        this.$message.error("服务费率必须大于0");
        return;
      }
      this.$refs.formData.validate(async valid => {
        if (valid) {
          let res = await switchSave({ mainAccountFlag: 1, ...this.form });
          if (res.status === 0) {
            this.$message.success("切换成功");
            this.$emit("updateList");
          }
        }
      });
    },
    getTaxPoint(e) {
      console.log("getTaxPoint========", e);
      this.form.branchCode = e;
      this.form.taxPoint = this.partyGroupOptions.filter(
        item => item.branchCode === e
      )[0].taxPoint;
      if (+this.form.taxPoint === 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    // 主体列表
    async switchingShipmentServiceFee(partyCode) {
      let res = await switchingShipmentServiceFee({ partyCode });
      console.log("主体列表==========", res);
      if (res.status === 0) {
        this.partyGroupOptions = res.data;
      }
    },
    cancelModel() {
      this.$emit("cancelModel");
    }
  }
};
</script>
